
export const BASE_URL = "https://python-pokemon-db.herokuapp.com";
